import { isBudgetManagerTagGroup } from '@domain/budget-manager/budget-manager.utils';

export const sortArrayByIndex = elements => elements.sort(
    (elementA, elementB) => elementA.index - elementB.index,
);

export const addIndex = (metrics, initIndex) => Object.entries(metrics)
    .reduce((acc, [key, metric], index) => ({
        ...acc,
        [key]: { ...metric, index: initIndex + index },
    }), {});

export const changeBudgetManagerColumnsVisibility = (metrics, groupSlug) => {
    const isBudgetManager = isBudgetManagerTagGroup(groupSlug);
    return {
        ...metrics,
        budget_manager_status: { ...metrics.budget_manager_status, isVisible: isBudgetManager },
        bid_manager_status: { ...metrics.bid_manager_status, isVisible: isBudgetManager },
        monthly_budget: { ...metrics.monthly_budget, isVisible: isBudgetManager },
        daily_budget_cluster: { ...metrics.daily_budget_cluster, isVisible: isBudgetManager },
    };
};
